import { render, staticRenderFns } from "./IntegralGoodsDetail.vue?vue&type=template&id=72a40794&scoped=true&"
import script from "./IntegralGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./IntegralGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntegralGoodsDetail.vue?vue&type=style&index=0&id=72a40794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a40794",
  null
  
)

export default component.exports